import React from "react";
import { Link } from "react-router-dom";

import styles from "./MoreGames.module.css";
import Language from "../utils/Language";
import Routes from "../constants/routes.json";

function pickLang(article) {
  const langIndex = Language.GetLangId();
  return article.languages[langIndex] || article.languages[0];
}

function MoreGames(props) {
  const games = require("../products/games.json");

  return (
    <section className={styles.Section}>
      <div className={styles.Head}>
        <div className={styles.HeadText}>
          <h2 className={styles.Title}>
            {Language.GetString("more_games_title")}
          </h2>
          <p className={styles.Subtitle}>
            {Language.GetString("more_games_subtitle")}
          </p>
        </div>
        <Link to={Routes.games} className={styles.ViewAll}>
          {Language.GetString("more_games")} →
        </Link>
      </div>

      <div className={styles.Grid}>
        {games.map(game => {
          const info = pickLang(game);
          const cover =
            (game.images && game.images[0] && game.images[0].full) ||
            (game.images && game.images[0] && game.images[0].thumb) ||
            game.symbol;
          return (
            <Link
              to={Routes.games}
              key={game.id}
              className={styles.Tile}
              aria-label={info.name}
            >
              <div className={styles.TileMedia}>
                <img alt="" src={cover} loading="lazy" />
              </div>
              <div className={styles.TileBody}>
                <div className={styles.TileName}>{info.name}</div>
                <div className={styles.TileMeta}>
                  <span className={styles.TileTag}>Free</span>
                  <span>{game.store ? game.store.name : ""}</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default MoreGames;
